import { createGlobalStyle } from 'styled-components';

const StyleOverrides = createGlobalStyle`
  html {
    box-sizing: border-box;
  }
  
  *, *:before, *:after {
    box-sizing: inherit;
  }

  body {
    margin: 0;
    font-family: ${({ theme }) => theme.typography.fonts.default};
    color: ${({ theme }) => theme.palette.black[100]};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    .ReactModalPortal .ReactModal__Overlay {
      z-index: 1500;
    }
  }

  h1 {
    margin: 0;
    padding: 0;
    font-size: ${(props) => props.theme.typography.sizes.h1};
    font-weight: ${(props) => props.theme.typography.weight.regular};
    font-family: ${({ theme }) => theme.typography.fonts.default};
  }

  h2 {
    margin: 0;
    padding: 0;
    font-size: ${(props) => props.theme.typography.sizes.h2};
    font-weight: ${(props) => props.theme.typography.weight.regular};
    font-family: ${({ theme }) => theme.typography.fonts.default};
  }

  h3 {
    margin: 0;
    padding: 0;
    font-size: ${(props) => props.theme.typography.sizes.h3};
    font-weight: ${(props) => props.theme.typography.weight.regular};
    font-family: ${({ theme }) => theme.typography.fonts.default};
  }

  p {
    margin: 0;
    padding: 0;
    font-size: ${(props) => props.theme.typography.sizes.small};
    font-weight: ${(props) => props.theme.typography.weight.regular};
    font-family: ${({ theme }) => theme.typography.fonts.default};
  }
`;

export default StyleOverrides;
